<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-user-manager-add-user">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 col-sm-12 p-4" v-if="Data">
            <form v-on:submit.prevent="userManagerAddUser">
              <h4>User Manager</h4>
              <hr />
              <div class="mb-2 rounded p-2" style="background-color: #f5f5f5;">
                <router-link
                  :to="{ name: 'Users' }"
                  class="d-inline"
                  style="font-weight: normal;"
                >
                  Users
                </router-link>
                <p class="d-inline pl-1 pr-1">/</p>
                <router-link
                  :to="{}"
                  class="d-inline"
                  style="font-weight: normal;"
                >
                  Edit user
                </router-link>
                <p class="d-inline pl-1 pr-1">/</p>
                <router-link
                  :to="{}"
                  class="d-inline"
                  style="font-weight: normal;"
                >
                  {{ UserName }}
                </router-link>
              </div>
              <h6>Edit user</h6>
              <br />
              <router-link
                class="btn btn-success text-sm mb-2"
                :to="{ name: 'DivvyAdminUsersLoginUser' }"
                @click.native="scrollToTop"
              >
                Login as user
              </router-link>
              <strong class="d-block">*These fields are required</strong>
              <div class="row my-3">
                <div class="col-sm-12 col-lg-8 col-md-8">
                  <div class="row my-2">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Username*:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input
                        v-model="UserName"
                        name="userName"
                        type="text"
                        autocomplete="off"
                        disabled
                      ></b-form-input>
                      <small>(no spaces, must be unique for each user)</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Password*:</strong>
                    </div>

                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input
                        style="cursor: not-allowed;"
                        disabled
                        v-model="Password"
                        v-if="!ShowPassword"
                        type="password"
                        name="password"
                        @focus="handleType"
                        @blur="handleType"
                        autocomplete="off"
                      ></b-form-input>
                      <b-form-input
                        style="cursor: not-allowed;"
                        disabled
                        v-model="Password"
                        v-if="ShowPassword"
                        type="text"
                        name="password"
                        autocomplete="off"
                      ></b-form-input>
                      <div>
                        <!-- Rounded switch -->
                        <div class="d-flex mt-1">
                          <strong style="line-height: 28px;">Show Password:</strong>

                          <div class="form-check form-switch ml-3">
                            <input
                              type="checkbox"
                              role="switch"
                              class="form-check-input"
                              v-model="ShowPassword"
                            />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6 d-flex align-items-center mb-1">
                            <button
                              type="button"
                              class="btn btn-primary ml-8 text-sm"
                              @click="emailPassword"
                            >
                              Email Password:
                            </button>
                            <span class="help-icon m-1" id="email-popover">
                              <font-awesome-icon
                                class="text-white"
                                icon="question"
                                transform="shrink-7"
                              />
                            </span>
                            <b-popover
                              triggers="hover"
                              target="email-popover"
                              ref="popover"
                            >
                              <div style="font-size:12px">
                                What this button is for?
                                <hr class="m-0 bg-dark" />
                                Sends password mail to user
                              </div>
                            </b-popover>
                          </div>
                          <div class="col-6 d-flex align-items-center mb-1">
                            <button
                              type="button"
                              class="btn btn-primary ml-8 text-sm pr-8"
                              @click="emailPassword"
                            >
                              Reset Password:
                            </button>
                            <span class="help-icon m-1" id="password-popover">
                              <font-awesome-icon
                                class="text-white"
                                icon="question"
                                transform="shrink-7"
                              />
                            </span>
                            <b-popover
                              triggers="hover"
                              target="password-popover"
                              ref="popover"
                            >
                              <div style="font-size:12px">
                                What this button is for?
                                <hr class="m-0 bg-dark" />
                                Resets user password and sends email to user
                              </div>
                            </b-popover>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Points:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input
                        style="cursor: not-allowed;"
                        disabled
                        v-model="StartingPoints"
                      ></b-form-input>

                      <router-link
                        class="btn btn-primary ml-8 text-sm mt-2"
                        :to="{
                          name: 'DivvyAdminUsersPointsUpdate',
                          params: { id: id },
                        }"
                        @click.native="scrollToTop"
                      >
                        Points
                      </router-link>
                    </div>
                  </div>

                  <div class="row my-3 py-1">
                    <div class="col-sm-12 col-lg-4 col-md-4 d-flex align-items-center">
                      <strong class="mb-0">Single Item Only:</strong>
                      <span class="help-icon m-1" id="single-item-only">
                        <font-awesome-icon
                          class="text-white"
                          icon="question"
                          transform="shrink-7"
                        />
                      </span>
                      <b-popover
                        triggers="hover"
                        target="single-item-only"
                        ref="popover"
                      >
                        <div style="font-size:12px">
                          Yes = Starting points become max point value for this
                          item
                        </div>
                      </b-popover>
                    </div>
                    <div
                      class="col-sm-12 col-lg-8 col-md-8 d-flex align-items-center"
                    >
                      <b-form-radio-group
                        v-model="SingleItem"
                        :options="SingleItemOptions"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                      ></b-form-radio-group>
                    </div>
                  </div>
                  <!-- Show transaction Start -->
                  <div class="row my-3 py-1">
                    <div class="col-sm-12 col-lg-4 col-md-4 d-flex align-items-center">
                      <strong class="mb-0">Show transaction:</strong>
                      <span class="help-icon m-1" id="show-transaction">
                        <font-awesome-icon
                          class="text-white"
                          icon="question"
                          transform="shrink-7"
                        />
                      </span>
                      <b-popover
                        triggers="hover"
                        target="show-transaction"
                        ref="popover"
                      >
                        <div style="font-size:12px">
                          Yes = Shows transcation report for normal users
                        </div>
                      </b-popover>
                    </div>
                    <div
                      class="col-sm-12 col-lg-8 col-md-8 d-flex justify-constant-center"
                    >
                      <b-form-radio-group
                        v-model="ShowTransaction"
                        :options="ShowTransactionOptions"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                      ></b-form-radio-group>
                    </div>
                  </div>
                  <!-- Show transaction End -->
                  <!-- Super admin ace Start -->
                  <div class="row my-3 py-1">
                    <div class="col-sm-12 col-lg-4 col-md-4 d-flex align-items-center">
                      <strong class="m-0">Super admin ace and bravo:</strong>
                      <span class="help-icon m-2" id="for-super-admin">
                        <font-awesome-icon
                          class="text-white"
                          icon="question"
                          transform="shrink-7"
                        />
                      </span>
                      <b-popover
                        triggers="hover"
                        target="for-super-admin"
                        ref="popover"
                      >
                        <div style="font-size:12px">
                          Yes = Super admin for Ace and Bravo
                        </div>
                      </b-popover>
                    </div>
                    <div
                      class="col-sm-12 col-lg-8 col-md-8 d-flex align-items-center"
                    >
                      <b-form-radio-group
                        v-model="SuperAdminAce"
                        :options="SuperAdminAceOptions"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                      ></b-form-radio-group>
                    </div>
                  </div>
                  <!-- Super admin ace End -->
                  <!-- Code Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Code:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="Code"></b-form-input>
                    </div>
                  </div>
                  <!-- Code End -->
                  <!-- Client List (single) Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Client:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-select
                        v-model="SelectClient"
                        class="form-control"
                      >
                        <option
                          v-for="client in getClientList"
                          :key="client.client_id"
                          :value="client.client_id"
                          >{{ client.client_name }}</option
                        >
                      </b-form-select>
                    </div>
                  </div>
                  <!-- Client List (single) End -->
                  <!-- Job Title Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Job title:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="JobTitle"></b-form-input>
                    </div>
                  </div>
                  <!-- Job Title End -->
                  <!-- First Name Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>First Name:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="FirstName"></b-form-input>
                    </div>
                  </div>
                  <!-- First Name End -->
                  <!-- Middle Name Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Middle Name:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="MiddleName"></b-form-input>
                    </div>
                  </div>
                  <!-- Middle Name End -->
                  <!-- Last Name Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Last Name:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="LastName"></b-form-input>
                    </div>
                  </div>
                  <!-- Last Name End -->
                  <!-- Address ATTN Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Address ATTN:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="AddressAtn"></b-form-input>
                    </div>
                  </div>
                  <!-- Address ATTN End -->
                  <!-- Address Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Address:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="Address"></b-form-input>
                    </div>
                  </div>
                  <!-- Address End -->
                  <!-- City Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>City:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="City"></b-form-input>
                    </div>
                  </div>
                  <!-- City End -->
                  <!-- State Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>State:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="State"></b-form-input>
                    </div>
                  </div>
                  <!-- State End -->
                  <!-- Zip Code Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Zip Code:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="ZipCode"></b-form-input>
                    </div>
                  </div>
                  <!-- Zip Code End -->
                  <!-- Day Phone Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Day Phone:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="DayPhone"></b-form-input>
                    </div>
                  </div>
                  <!-- Day Phone End -->
                  <!-- Evening Phone Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Evening Phone:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="EveningPhone"> </b-form-input>
                    </div>
                  </div>
                  <!-- Evening Phone End -->
                  <!-- Email Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Email:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input type="text" v-model="Email"></b-form-input>
                    </div>
                  </div>
                  <!-- Email Start -->
                  <!-- SSN Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Social Security No.:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="SocialSecurityNo"></b-form-input>
                      <small>(Optional, no dashes. Ex: 123456789)</small>
                    </div>
                  </div>
                  <!-- SSN End -->
                  <!-- Select Admin Start -->
                  <div class="row my-3 ">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Admin:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-select v-model="SelectAdmin">
                        <option :value="0">No</option>
                        <option :value="1">Full Admin</option>
                        <option :value="2">Client Admin</option>
                        <option :value="3">Ameritech Coach</option>
                        <option :value="4">Ameritech Sr.Manager</option>
                        <option :value="5">Ameritech President</option>
                        <option :value="6">Ameritech Vice-President</option>
                        <option :value="7">Ameritech Regional Director</option>
                      </b-form-select>
                    </div>
                  </div>
                  <!-- Select Admin End -->
                  <!-- Client List (multiple) Start -->
                  <div class="row my-3 form-group">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Admin:</strong>
                    </div>
                    <div class="col">
                      <select
                        size="6"
                        v-model="SelectAdminList"
                        multiple
                        :disabled="SelectAdmin !== 2"
                        :style="[
                          SelectAdmin !== 2
                            ? { cursor: 'not-allowed' }
                            : { cursor: 'pointer' },
                        ]"
                        class="form-control"
                      >
                        <option
                          v-for="client in getClientList"
                          :key="client.client_id"
                          :value="client.client_id"
                          >{{ client.client_name }}</option
                        >
                      </select>
                      <small
                        >When no clients are selected from this list, this admin
                        will only have access to the client that they are
                        assigned to above. Selecting 1 or more clients from this
                        list will give this admin access to the features of
                        these clients. If 1 or more clients are selected, then
                        that admin's own client must be selected for that admin
                        to see their own client users.</small
                      >
                    </div>
                  </div>
                  <!-- Client List (multiple) End -->
                  <!-- Joining Date Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Joining Date:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="JoiningDate"></b-form-input>
                      <small>(Month/Day/Year) eg: 12/12/2022</small>
                    </div>
                  </div>
                  <!-- Joining Date End -->
                  <!-- Birthday Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Birthday:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="BirthDay"></b-form-input>
                      <small>(Month/Day) eg: 12/12</small>
                    </div>
                  </div>
                  <!-- Birthday End -->
                  <!-- Birthyear Start -->
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <strong>Birthyear:</strong>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="BirthYear"></b-form-input>
                      <small>(Year) eg: 2022</small>
                    </div>
                  </div>
                  <!-- Birthyear End -->
                </div>
              </div>
              <!-- Button Area Start-->
              <div class="mt-3">
                <input
                  class="btn btn-primary btn-sm-block mr-2"
                  type="submit"
                  name="add"
                  value="Update"
                />
                <router-link
                  :to="{
                    name: 'Users',
                  }"
                  @click.native="scrollToTop"
                  class="btn btn-danger text-white btn-sm-block mr-2"
                  type="button"
                  >Cancel</router-link
                >
              </div>
              <!-- Button Area End-->
            </form>

            <table class="table table table-bordered mt-3">
              <tbody>
                <tr>
                  <td class="font-weight-bold">
                    Created By:
                  </td>
                  <td>
                    {{ CreatedBy }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">
                    Created on:
                  </td>
                  <td>{{ CreatedOn[0] }} {{ CreatedOn[1] }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">
                    Last edited by:
                  </td>
                  <td>
                    {{ LastEditedBy }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">
                    Last edited on:
                  </td>
                  <td>{{ LastEditedOn[0] }} {{ LastEditedOn[1] }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">
                    Login date:
                  </td>
                  <td>
                    {{ LoginDate }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import moment from "moment";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

import {
  getCustomizedTimestamp,
  validateMonthDateYearFormat,
  validateMonthDay,
  validateYear,
} from "@/utilities/date.js";

export default {
  name: "UsersEditUser",
  props: ["id"],
  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: DivvyAdminSidebar,
  },

  data() {
    return {
      Data: null,
      Email: "",
      UserName: "",
      Password: "",
      ShowPassword: false,
      StartingPoints: 0,
      SingleItem: false,
      SingleItemOptions: [
        { item: true, name: "Yes" },
        { item: false, name: "No" },
      ],
      ShowTransaction: false,
      ShowTransactionOptions: [
        { item: true, name: "Yes" },
        { item: false, name: "No" },
      ],
      SuperAdminAce: false,
      SuperAdminAceOptions: [
        { item: true, name: "Yes" },
        { item: false, name: "No" },
      ],
      Code: "",
      SelectClient: 0,
      JobTitle: "",
      FirstName: "",
      MiddleName: "",
      LastName: "",
      AddressAtn: "",
      Address: "",
      City: "",
      State: "",
      ZipCode: "",
      DayPhone: "",
      EveningPhone: "",
      SocialSecurityNo: "",
      SelectAdmin: 0,
      SelectAdminList: [],
      JoiningDate: "",
      BirthDay: "",
      BirthYear: "",
      // fieldTypes: {
      //   password: "text",
      // },
      CreatedBy: "",
      CreatedOn: [],
      LastEditedBy: "",
      LastEditedOn: [],
      LoginDate: "",
    };
  },

  computed: {
    getClientList() {
      return this.$store.getters["manageUsers/getClientList"];
    },
  },

  watch: {
    SelectAdmin(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (newVal !== 2 && oldVal === 2) {
        this.SelectAdminList = [];
      }
    },
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersmodule",
        activeMenu: this.activeMenu ? this.activeMenu : "clientusermanagement",
      });
    },
    userManagerAddUser: function() {
      if (!this.UserName) {
        alert("Username is required.");
      } else if (!this.Password) {
        alert("Password is required.");
      }

      if(this.UserName.indexOf(' ') >= 0){
        console.log("Yes");
        alert("no spaces between username");
        return;
      }

      this.JoiningDate =
        this.JoiningDate &&
        moment(this.JoiningDate, "MM/DD/YYYY", true).isValid()
          ? this.JoiningDate
          : "";
      this.BirthDay =
        this.BirthDay && validateMonthDay(this.BirthDay) ? this.BirthDay : "";
      this.BirthYear =
        this.BirthYear && validateYear(this.BirthYear) ? this.BirthYear : "";

      if (this.UserName && this.Password) {
        const payload = {
          user_id: +this.id,
          username: this.UserName,
          password: this.Password,
          code: this.Code,
          company: "",
          points: +this.StartingPoints,
          admin: +this.SelectAdmin,
          singleitem: this.SingleItem,
          firstname: this.FirstName,
          middleinitial: this.MiddleName,
          lastname: this.LastName,
          address1: this.AddressAtn,
          address2: this.Address,
          city: this.City,
          state: this.State,
          zip: this.ZipCode,
          dayphone: this.DayPhone,
          eveningphone: this.EveningPhone,
          email: this.Email,
          ssn: this.SocialSecurityNo,
          joiningdate: this.JoiningDate
            ? moment(this.JoiningDate).format("YYYY-MM-DD")
            : "",
          birthday: this.BirthDay,
          birthyear: this.BirthYear,
          client_id: Number(this.SelectClient),
          client_ids: this.SelectAdminList,
          istranscreport: this.ShowTransaction,
          superadminacebravo: this.SuperAdminAce,
          jobTitle: this.JobTitle,
        };

        this.$store
          .dispatch("manageUsers/updateUser", payload)
          .then((userId) => {
            console.log("succesfully updated the user", userId);
            this.$store.dispatch("manageUsers/fetchGetUsers");
          })
          .then(() => {
            this.$router.push({
              name: "DivvyAdminUsersAddUpdScreen",
              params: { Name: this.UserName, action: "updated" },
            });
          })
          .catch(() => {
            console.log("error occured in users < UsersEditUser");
          });
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleType(event) {
      const { srcElement, type } = event;
      const { name, value } = srcElement;

      if (type === "blur" && !value) {
        this.fieldTypes[name] = "text";
      } else {
        this.fieldTypes[name] = "password";
      }
    },
    setData(data) {
      this.Data = data;
      this.Email = data.email;
      this.UserName = data.username;
      this.Password = data.password;
      this.StartingPoints = +data.pointsAvailable;
      this.SingleItem = data.singleItem;
      this.ShowTransaction = data.istranscreport;
      this.SuperAdminAce = data.superadminacebravo;
      this.Code = data.code;
      this.SelectClient = Number(data.client);
      this.JobTitle = data.jobTitle;
      this.FirstName = data.firstName;
      this.MiddleName = data.middleInitial;
      this.LastName = data.lastName;
      this.AddressAtn = data.address1;
      this.Address = data.address2;
      this.City = data.city;
      this.State = data.state;
      this.ZipCode = data.zip;
      this.DayPhone = data.dayPhone;
      this.EveningPhone = data.eveningPhone;
      this.SocialSecurityNo = data.ssn;
      this.SelectAdmin = +data.admin;
      this.SelectAdminList = data.clients
        ? data.clients.split(",").map((x) => +x)
        : [];
      let date = data.joiningDate;
      if (date) {
        date = date.substr(0, 10);
        this.JoiningDate = moment(date).format("MM/DD/YYYY");
      }
      this.BirthDay = data.birthday;
      this.BirthYear = data.birthyear;
      this.CreatedBy = data.createdbyadminusername;
      this.CreatedOn = data.createddate.slice(0, -1).split("T");
      this.LastEditedBy = data.editedbyadminusername;
      this.LastEditedOn = data.editeddate.slice(0, -1).split("T");
      this.LoginDate = data.loginDate;
    },
    emailPassword() {
      this.$store
        .dispatch("manageUsers/emailPassword", {
          userId: this.$route.params.id,
        })
        .then((data) => {
          alert(data);
        });
    },
  },
  created() {
    this.scrollToTop();
    this.setActiveMenuItem();
    this.$store.dispatch("manageUsers/fetchGetUserClients");
    this.$store
      .dispatch("manageUsers/fetchExistingDetails", {
        userId: this.id,
      })
      .then((data) => {
        console.log(`prefilldata:`, data);
        this.setData(data);
      });
  },
};
</script>

<style lang="scss" scoped>
.admin-user-manager-add-user {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

.help-icon {
  background-color: $primary;
  height: 15px;
  width: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

// h4:after {
//   content: none;
// }

.datetime-style {
  background-color: blue;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #3782f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #3782f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
// .slider.round {
//   border-radius: 34px;
// }

// .slider.round:before {
//   border-radius: 50%;
// }

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
}
</style>
